export const faqContent = [
  {
    title: 'helpPage.canIUseMultipleAccountTitle',
    description: 'helpPage.canIUseMultipleAccountDescription',
  },
  {
    title: 'helpPage.canILoginWithDifferentDeviceTitle',
    description: 'helpPage.canILoginWithDifferentDeviceDescription',
  },
  {
    title: 'helpPage.howDoITransferCyphlensAccountTitle',
    description: 'helpPage.howDoITransferCyphlensAccountDescription',
  },
  {
    title: 'helpPage.whyToAddEmergencyContactTitle',
    description: 'helpPage.whyToAddEmergencyContactDescription',
  },
  {
    title: 'helpPage.whatToDoIfDeviceStolenTitle',
    description: 'helpPage.whatToDoIfDeviceStolenDescription',
  },
  {
    title: 'helpPage.whatDoesLockIconDoTitle',
    description: 'helpPage.whatDoesLockIconDoDescription',
  },
  {
    title: 'helpPage.whatDoesSunIconDoTitle',
    description: 'helpPage.whatDoesSunIconDoDescription',
  },
  {
    title: 'helpPage.howToUpdatePasswordTitle',
    description: 'helpPage.howToUpdatePasswordDescription',
  },
  {
    title: 'helpPage.howToReceiveAssistanceTitle',
    description: 'helpPage.howToReceiveAssistanceDescription',
  },
];
